import { render } from "./AuthForm.vue?vue&type=template&id=5e303c60"
import script from "./AuthForm.vue?vue&type=script&lang=js"
export * from "./AuthForm.vue?vue&type=script&lang=js"

import exportComponent from "D:\\ASMPP\\ASMPP_VUE\\asmpp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__